<app-page-shell *ngIf="canViewClearance">
    <app-page-hero
        eyebrow="Operations"
        title="List Clearances"
        subtitle="Search, filter, and open clearance workspaces.">
        <div actions>
            <p-button label="Overview" icon="pi pi-chart-line" severity="secondary" [outlined]="true" routerLink="/clearance"></p-button>
            <p-button *ngIf="canCreateClearance" label="Create Clearance" icon="pi pi-plus" (click)="addClearance()"></p-button>
        </div>
    </app-page-hero>

    <app-page-data-panel title="Clearance Jobs" [subtitle]="'Focused operations view for GCC/KSA clearance work'" [resultText]="visibleClearances.length + ' shown'">
        <div actions>
            <p-button icon="pi pi-refresh" label="Refresh" severity="secondary" [outlined]="true" (click)="loadData()"></p-button>
        </div>

        <div class="clearance-filters">
            <app-logistics-project-lookup placeholder="Project" [(ngModel)]="selectedLogisticsProjectId" (ngModelChange)="loadData()"></app-logistics-project-lookup>
            <p-select [options]="statusOptions" [(ngModel)]="statusFilter" optionLabel="label" optionValue="value"
                placeholder="Status" [showClear]="true" styleClass="w-full"></p-select>
            <input pInputText [(ngModel)]="brokerFilter" placeholder="Broker" />
            <input pInputText [(ngModel)]="portFilter" placeholder="Port / Customs location" />
            <p-datePicker [(ngModel)]="etaFrom" placeholder="ETA from" styleClass="w-full"></p-datePicker>
            <p-datePicker [(ngModel)]="etaTo" placeholder="ETA to" styleClass="w-full"></p-datePicker>
        </div>

        <p-table [value]="visibleClearances" dataKey="clearanceHeaderID" [paginator]="true" [rows]="10" [lazy]="true"
            (onLazyLoad)="loadData($event)" [totalRecords]="totalRecords" [loading]="isLoading"
            styleClass="p-datatable-gridlines p-datatable-sm" [tableStyle]="{ 'min-width': '76rem' }"
            [rowsPerPageOptions]="[10, 20, 50, 100]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="jobNumber">Job # <p-sortIcon field="jobNumber"></p-sortIcon></th>
                    <th pSortableColumn="consignee.name">Client / Consignee <p-sortIcon field="consignee.name"></p-sortIcon></th>
                    <th>Broker</th>
                    <th>Project</th>
                    <th>Port</th>
                    <th pSortableColumn="eta">ETA <p-sortIcon field="eta"></p-sortIcon></th>
                    <th>Readiness</th>
                    <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
                    <th>Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-clearance>
                <tr>
                    <td>
                        <div class="font-bold text-900">{{ clearance.jobNumber || clearance.clearanceJobNumber || '-' }}</div>
                        <div class="text-xs text-500">{{ clearance.bayanNumber || 'No Bayan yet' }}</div>
                    </td>
                    <td>
                        <div class="flex align-items-center gap-2">
                            <p-image src="{{ clearance.consignee?.logo ?? 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png' }}"
                                alt="Consignee Logo" height="30px" imageClass="border-round"></p-image>
                            <div>
                                <div class="font-semibold">{{ clearance.consignee?.name || '-' }}</div>
                                <div class="text-xs text-500">{{ clearance.shipper?.shipperName || 'No shipper' }}</div>
                            </div>
                        </div>
                    </td>
                    <td>{{ clearance.broker?.name || '-' }}</td>
                    <td>
                        <div class="font-semibold">{{ clearance.logisticsProjectId ? ('Project #' + clearance.logisticsProjectId) : 'Unassigned' }}</div>
                        <div class="text-xs text-500">{{ clearance.logisticsProjectId ? 'Linked job file' : 'No project context' }}</div>
                    </td>
                    <td>
                        <div>{{ clearance.pod || clearance.customsLocation || '-' }}</div>
                        <div class="text-xs text-500">{{ clearance.incoterm || 'No incoterm' }}</div>
                    </td>
                    <td>
                        <div>{{ clearance.eta | date:'yyyy-MM-dd' }}</div>
                        <p-tag *ngIf="isPreClearanceLate(clearance)" value="Late" severity="danger" styleClass="mt-1"></p-tag>
                    </td>
                    <td>
                        <p-tag [value]="isPreClearanceLate(clearance) ? 'Late' : 'Check workspace'"
                            [severity]="isPreClearanceLate(clearance) ? 'danger' : 'info'"></p-tag>
                    </td>
                    <td>
                        <p-tag [value]="clearance.status" [severity]="getSeverity(clearance.status)"></p-tag>
                    </td>
                    <td>
                        <span class="p-buttonset">
                            <button pButton pRipple icon="pi pi-briefcase" class="p-button-rounded p-button-text p-button-info"
                                (click)="viewClearance(clearance)" pTooltip="Open Workspace"></button>
                            <button *ngIf="clearance.logisticsProjectId" pButton pRipple icon="pi pi-sitemap"
                                class="p-button-rounded p-button-text p-button-secondary" (click)="openProject(clearance)"
                                pTooltip="Open Project"></button>
                            <button *ngIf="canEditClearance" pButton pRipple icon="pi pi-pencil"
                                class="p-button-rounded p-button-text p-button-success" (click)="editClearance(clearance)"
                                pTooltip="Edit Header"></button>
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="9" class="text-center">No clearances found.</td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
</app-page-shell>

<app-page-shell *ngIf="!canViewClearance">
    <app-page-data-panel title="Customs Clearance" subtitle="You do not have permission to view clearance records."></app-page-data-panel>
</app-page-shell>
